import { NgModule } from '@angular/core';

import { ChapterItemComponent } from './chapter-item.component';
import { ChapterStepComponent } from './chapter-step/chapter-step.component';
import { ChapterSubtitleDirective } from './chapter-subtitle.directive';
import { ChapterTitleDirective } from './chapter-title.directive';

const standalone = [ChapterItemComponent, ChapterTitleDirective, ChapterSubtitleDirective, ChapterStepComponent];

@NgModule({
  imports: standalone,
  exports: standalone,
})
export class OnboardingChapterModule {}
